// IMPROVED PRODUCT DETAILS & MULTI-FULFILLMENT PURCHASE OPTIONS
import React, { Fragment, useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import Loader from "../../layout/loader";
import MetaTag from "../../layout/MetaTag";
import swal from "sweetalert";
import ImageGallery from "react-image-gallery";

import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";

import ReactStars from "react-rating-stars-component";
import { Helmet } from "react-helmet";
import FavoriteIcon from "@mui/icons-material/Favorite";

import RealtedBrand from "./SimilarProductsFile/RealtedBrand";
import Navbar from "../HomeScreen/Navbar";
import Footer from "../HomeScreen/bottomsection/Footer";
import Reviews from "../review/Reviews";
import RecentlyViewedProducts from "../recentlyViewed/RecentlyViewedProducts";

import "./producttreview.css";

import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AssignmentIcon from "@mui/icons-material/Assignment";
import StorefrontIcon from "@mui/icons-material/Storefront";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField
} from "@material-ui/core";

import {
  productDetailAction,
  clearErrorAction,
} from "../../redux/actions/productAction";

import { addProductToWishListAction } from "../../redux/actions/wishListAction";
import { ADD_PRODUCT_REQUEST_RESET } from "../../redux/constants/wishListConstant";
import { cartAction } from "../../redux/actions/cartAction";
import { ADD_TO_CART_RESET } from "../../redux/constants/cartConstants";
import { saveRecentlyViewedProduct } from "../../utils/recentlyViewedProducts";

const SITE_URL = "https://imonline.shop";
const DEFAULT_PRODUCT_IMAGE = `${SITE_URL}/output-onlinepngtools.png`;

const cleanText = (value = "") => String(value).replace(/\s+/g, " ").trim();

const truncateText = (value, maxLength = 155) => {
  const text = cleanText(value);
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength - 1).trim()}...`;
};

const getProductImages = (product = {}) => {
  const imageUrls = [...(product.image || []), ...(product.mainImage || [])]
    .map((item) => item && item.imageurl)
    .filter(Boolean);

  return imageUrls.length > 0
    ? [...new Set(imageUrls)]
    : [DEFAULT_PRODUCT_IMAGE];
};

const getProductPrice = (product = {}) => {
  const price = Number(product.price) || 0;
  const discountPrice = Number(product.discountPrice) || 0;
  return product.discountActive ? Math.max(price - discountPrice, 0) : price;
};

const padProductImages = (imagesArray) => {
  const padded = [...imagesArray];
  if (padded.length === 0) return [DEFAULT_PRODUCT_IMAGE];
  let index = 0;
  while (padded.length < 8) {
    padded.push(imagesArray[index % imagesArray.length]);
    index++;
  }
  return padded;
};

function Productcartdetail(props) {
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.user || {});

  const {
    error: wishListError,
    loading: wishListLoading,
    isProductAdd,
  } = useSelector((state) => state.wishListAdd);

  const {
    error,
    loading,
    product = {},
  } = useSelector((state) => state.productDetail);

  const {
    error: addtoCartError,
    isProductAdded,
    loading: addtoCartLoading,
  } = useSelector((state) => state.cart);

  const [quantity, setQuantity] = useState(1);
  const [size, setSize] = useState();
  const [colour, setColour] = useState();
  const [selectBox, setSelectBox] = useState("0");
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);

  // Fulfillment Capabilities State from Backend
  const [fulfillmentCapabilities, setFulfillmentCapabilities] = useState(null);
  const [isPurchaseModalOpen, setIsPurchaseModalOpen] = useState(false);
  const [selectedPurchaseOption, setSelectedPurchaseOption] = useState("HOME_DELIVERY");
  const [sizeGuideOpen, setSizeGuideOpen] = useState(false);

  // Customer Checkout Inputs
  const [customerName, setCustomerName] = useState("");
  const [customerPhone, setCustomerPhone] = useState("");
  const [customerEmail, setCustomerEmail] = useState("");
  const [customerAddress, setCustomerAddress] = useState("");
  const [customerCity, setCustomerCity] = useState("Delhi");
  const [customerPincode, setCustomerPincode] = useState("110001");
  const [customerPickupLocationId, setCustomerPickupLocationId] = useState("");
  const [isProcessingPurchase, setIsProcessingPurchase] = useState(false);
  const [purchaseSuccessData, setPurchaseSuccessData] = useState(null);

  // Sync user details if logged in
  useEffect(() => {
    if (user) {
      setCustomerName(`${user.firstName || ''} ${user.lastName || ''}`.trim() || user.name || "");
      setCustomerEmail(user.email || "");
      setCustomerPhone(user.phone || "");
    }
  }, [user]);

  // Fetch product fulfillment capabilities
  useEffect(() => {
    if (product && product._id) {
      axios.get(`/api/marketplace/product/${product._id}/fulfillment-options`)
        .then(res => {
          if (res.data?.success) {
            setFulfillmentCapabilities(res.data);
          }
        })
        .catch(err => {
          console.error("Failed to load fulfillment options:", err);
        });
    }
  }, [product]);

  useEffect(() => {
    if (error) {
      swal({
        title: "Error",
        text: error,
        icon: "error",
      });
      dispatch(clearErrorAction());
    }

    if (addtoCartError) {
      swal({
        title: "Error",
        text: addtoCartError,
        icon: "error",
      });
      dispatch(clearErrorAction());
    }

    if (isProductAdded) {
      swal({
        title: "Product Added",
        text: isProductAdded,
        icon: "success",
      });
      dispatch({ type: ADD_TO_CART_RESET });
    }

    if (addtoCartLoading) {
      swal("Please Wait....", {
        button: false,
      });
    }

    if (wishListError) {
      swal({
        title: "Error",
        text: wishListError,
        icon: "error",
      });
      dispatch(clearErrorAction());
    }

    if (wishListLoading) {
      swal("Please Wait....", {
        button: false,
      });
    }

    if (isProductAdd) {
      swal({
        title: "Success",
        text: "Added to Wishlist.",
        icon: "success",
      });
      dispatch({ type: ADD_PRODUCT_REQUEST_RESET });
    }
  }, [
    dispatch,
    error,
    isProductAdd,
    wishListError,
    wishListLoading,
    addtoCartError,
    addtoCartLoading,
    isProductAdded,
  ]);

  const productIdentifier = props.match?.params?.slug || props.match?.params?.id;

  useEffect(() => {
    if (productIdentifier) {
      dispatch(productDetailAction(productIdentifier));
    }
  }, [dispatch, productIdentifier]);

  useEffect(() => {
    if (product && product._id) {
      saveRecentlyViewedProduct(product);
    }
  }, [product]);

  const incrementQuantity = () => {
    if (product.productStock <= quantity) {
      return swal({
        title: "Stock Limit",
        text: `Only ${product.productStock} item(s) available.`,
        icon: "info",
      });
    }
    setQuantity(quantity + 1);
  };

  const decrementQuantity = () => {
    if (quantity <= 1) return;
    setQuantity(quantity - 1);
  };

  const submitHandler = (e) => {
    e.preventDefault();

    if (product.sizeOfShoes?.length > 0 && !size) {
      return swal({
        title: "Selection Required",
        text: "Please select your size before adding to cart.",
        icon: "info",
      });
    }

    if (product.colorOfShoes?.length > 0 && !colour) {
      return swal({
        title: "Selection Required",
        text: "Please select your colour before adding to cart.",
        icon: "info",
      });
    }

    dispatch(
      cartAction(
        product._id,
        quantity,
        size || product.sizeOfShoes?.[0] || 0,
        colour || product.colorOfShoes?.[0] || "Standard",
        selectBox || "0",
        product.shippingCharges || 0
      )
    );
  };

  // Open Multi-Fulfillment Purchase Modal
  const handleOpenPurchaseOption = (optionType) => {
    if (product.productStock < 1) {
      return swal("Out of Stock", "This product is currently out of stock.", "info");
    }

    if (product.sizeOfShoes?.length > 0 && !size) {
      return swal({
        title: "Selection Required",
        text: "Please select a size first.",
        icon: "info",
      });
    }

    if (product.colorOfShoes?.length > 0 && !colour) {
      return swal({
        title: "Selection Required",
        text: "Please select a colour first.",
        icon: "info",
      });
    }

    setSelectedPurchaseOption(optionType);
    setPurchaseSuccessData(null);
    setIsPurchaseModalOpen(true);
  };

  // Log Seller Call / Direct Contact
  const handleCallSeller = () => {
    const store = product.store || fulfillmentCapabilities?.store;
    const phone = store?.phone || store?.contact?.phone || store?.pickupAddress?.phone;

    if (!phone) {
      return swal("Contact Unavailable", "Seller phone contact is not listed. Please use online delivery or store pickup.", "info");
    }

    axios.post('/api/marketplace/seller-contact/event', {
      storeId: store._id || store.id,
      productId: product._id,
      actionType: "CALL"
    }).catch(() => {});

    window.location.href = `tel:${phone}`;
  };

  // Execute Order / Reservation / Booking Submission
  const handleExecutePurchase = async (e) => {
    e.preventDefault();

    if (!customerPhone || customerPhone.length < 10) {
      return swal("Validation", "Please enter a valid 10-digit mobile phone number.", "warning");
    }

    if (!customerName || customerName.trim().length < 2) {
      return swal("Validation", "Please enter your name.", "warning");
    }

    if (selectedPurchaseOption === "HOME_DELIVERY" && (!customerAddress || customerAddress.trim().length < 5)) {
      return swal("Validation", "Please provide your complete delivery address.", "warning");
    }

    try {
      setIsProcessingPurchase(true);

      const payload = {
        orderType: selectedPurchaseOption,
        productId: product._id,
        quantity,
        size: size || product.sizeOfShoes?.[0] || 0,
        colour: colour || product.colorOfShoes?.[0] || "Standard",
        customerInfo: {
          name: customerName.trim(),
          phone: customerPhone.trim(),
          phoneNo: Number(customerPhone.trim()),
          email: customerEmail.trim() || `${customerPhone}@imonline.shop`,
          address: customerAddress.trim(),
          city: customerCity.trim() || "Delhi",
          pincode: Number(customerPincode) || 110001,
          state: "Delhi",
          pickupLocationId: customerPickupLocationId || undefined
        },
        paymentInfo: {
          id: selectedPurchaseOption === "BOOKING" ? "PAY_AT_STORE" : "ONLINE_ORDER",
          status: selectedPurchaseOption === "BOOKING" ? "Pay at Store" : "Order Placed"
        }
      };

      const res = await axios.post('/api/marketplace/purchase/checkout', payload);
      if (res.data?.success) {
        setPurchaseSuccessData(res.data);
      }
    } catch (err) {
      swal("Error", err.response?.data?.msg || "Could not complete your request. Please try again.", "error");
    } finally {
      setIsProcessingPurchase(false);
    }
  };

  const options = {
    edit: false,
    color: "#d1d5db",
    activeColor: "#facc15",
    size: window.innerWidth < 600 ? 20 : 25,
    value: product.ratings || 0,
    isHalf: true,
  };

  const canonicalUrl = product?._id
    ? `${SITE_URL}/product/${product.slug || product._id}`
    : `${SITE_URL}/Product`;
  const productImages = useMemo(() => padProductImages(getProductImages(product)), [product]);
  const productDescription =
    truncateText(product.discription) ||
    `Buy ${product.name || "premium shoes"} online at IM Online Shop.`;
  const productImage = productImages[0];
  const productPrice = getProductPrice(product);

  const structuredData = useMemo(() => {
    if (!product || !product.name) return null;

    const productSchema = {
      "@context": "https://schema.org/",
      "@type": "Product",
      "@id": `${canonicalUrl}#product`,
      name: product.name,
      url: canonicalUrl,
      image: productImages,
      description: productDescription,
      sku: product._id,
      category: product.category,
      brand: {
        "@type": "Brand",
        name: product.brandName || "IM Online Shop",
      },
      offers: {
        "@type": "Offer",
        url: canonicalUrl,
        priceCurrency: "INR",
        price: String(productPrice),
        availability:
          product.productStock > 0
            ? "https://schema.org/InStock"
            : "https://schema.org/OutOfStock",
        priceValidUntil: new Date(
          new Date().setFullYear(new Date().getFullYear() + 1)
        ).toISOString(),
        itemCondition: "https://schema.org/NewCondition",
        seller: {
          "@type": "Organization",
          name: product.store?.name || "IM Online Shop",
        },
      },
    };

    if (
      product.reviews &&
      product.reviews.length > 0 &&
      Number(product.ratings) > 0
    ) {
      productSchema.aggregateRating = {
        "@type": "AggregateRating",
        ratingValue: String(product.ratings),
        reviewCount: String(product.numOfReviews),
      };
    }

    return productSchema;
  }, [canonicalUrl, product, productDescription, productImages, productPrice]);

  const images = useMemo(() => {
    return productImages.map((imageUrl, index) => ({
      original: imageUrl,
      thumbnail: imageUrl,
      thumbnailAlt: `${product.name || "Product"} - view ${index + 1}`,
    }));
  }, [productImages, product.name]);

  const wishListSubmitHandler = (id) => {
    dispatch(addProductToWishListAction(id));
  };

  const caps = fulfillmentCapabilities?.capabilities || product?.capabilities;
  const storeInfo = fulfillmentCapabilities?.store || product?.store;

  const unitAdvance = caps?.advanceReservation?.advanceAmount || product?.fulfillmentOverrides?.advanceAmount || 300;
  const totalItemPrice = productPrice * quantity;
  const totalAdvance = Math.min(unitAdvance * quantity, totalItemPrice);
  const totalRemainingAtShop = Math.max(totalItemPrice - totalAdvance, 0);

  const homeDeliveryEnabled = caps ? caps.homeDelivery?.enabled !== false : true;
  const storePickupEnabled = caps ? caps.storePickup?.enabled !== false : true;
  const advanceReservationEnabled = caps ? caps.advanceReservation?.enabled !== false : true;
  const bookingEnabled = caps ? caps.bookingWithoutPayment?.enabled !== false : true;
  const directCallEnabled = caps ? (caps.directCall?.enabled !== false && !!(caps.directCall?.phone || storeInfo?.phone || storeInfo?.contact?.phone)) : true;

  return (
    <Fragment>
      {loading ? (
        <MetaTag
          title="Loading Product | IM Online Shop"
          description="Loading product details from IM Online Shop."
          robots="noindex, follow"
        />
      ) : (
        <MetaTag
          title={`${product.name || product.metaTag} | Buy ${
            product.brandName || "Shoes"
          } Online | IM Online Shop`}
          description={productDescription}
          keywords={`${product.name}, ${product.brandName}, ${product.category}, buy ${product.name} online, sneakers, footwear, mens shoes, IM Online Shop`}
          canonical={canonicalUrl}
          image={productImage}
          type="product"
          schema={structuredData}
        />
      )}

      {loading ? (
        <Loader />
      ) : (
        <Fragment>
          <Helmet>
            <title>{`${product.name} | Buy ${product.brandName} Online at Best Price - IMONLINE.SHOP`}</title>
            <meta property="og:type" content="product" />
            <meta
              property="product:price:amount"
              content={String(productPrice || "")}
            />
            <meta property="product:price:currency" content="INR" />
          </Helmet>
          <Navbar />

          <div className="product-detail-shell">
            <div className="product-detail-grid">
              <section className="product-detail-gallery-card">
                <div className="product-detail-gallery-top">
                  <span>{product.tag || "Featured pair"}</span>
                  <button
                    type="button"
                    onClick={() => wishListSubmitHandler(product._id)}
                    className="product-detail-wishlist"
                    aria-label="Add product to wishlist"
                  >
                    <FavoriteIcon />
                  </button>
                </div>
                <ImageGallery items={images} />
              </section>

              <section className="product-detail-info-card">
                <div className="product-detail-info-top">
                  <span className="product-detail-kicker">
                    {product.brandName || "IM Online Shop"}
                  </span>
                  <span
                    className={
                      product.productStock < 1
                        ? "product-stock-pill stock-out"
                        : "product-stock-pill stock-in"
                    }
                  >
                    {product.productStock < 1 ? "Out Of Stock" : "In Stock"}
                  </span>
                </div>

                <h1 className="product-detail-title">{product.name}</h1>

                <div className="product-detail-rating-row">
                  <ReactStars {...options} />
                  <span>({product.numOfReviews || 0} Reviews)</span>
                </div>

                <div className="product-detail-price-card">
                  <span>Price</span>
                  <div>
                    {product.discountActive && <s>₹{product.price}</s>}
                    <strong>₹{productPrice}</strong>
                    {product.discountActive && <em>Sale</em>}
                  </div>
                </div>

                <div className="product-detail-facts">
                  <div>
                    <span>Brand</span>
                    <strong>{product.brandName || "IM Online Shop"}</strong>
                  </div>
                  <div>
                    <span>Quality</span>
                    <strong>{product.qualityType || "FC 10A Quality"}</strong>
                  </div>
                  <div>
                    <span>Available</span>
                    <strong>{product.productStock || 0} pairs</strong>
                  </div>
                </div>

                <div className="product-detail-control-row">
                  <div className="product-detail-quantity">
                    <span>Quantity</span>
                    <div>
                      <button
                        type="button"
                        onClick={decrementQuantity}
                        aria-label="Decrease quantity"
                      >
                        <RemoveIcon />
                      </button>
                      <input type="number" readOnly value={quantity} />
                      <button
                        type="button"
                        onClick={incrementQuantity}
                        aria-label="Increase quantity"
                      >
                        <AddIcon />
                      </button>
                    </div>
                  </div>
                </div>

                <div className="product-detail-select-grid">
                  <label>
                    <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      Size
                      <button 
                        type="button" 
                        onClick={() => setSizeGuideOpen(true)}
                        style={{ background: 'none', border: 'none', color: '#8b2626', cursor: 'pointer', fontSize: '11px', display: 'flex', alignItems: 'center', gap: '3px', padding: 0, fontWeight: '700' }}
                      >
                        <AssignmentIcon style={{ fontSize: '13px' }} /> Size Guide
                      </button>
                    </span>
                    <select
                      onChange={(e) => setSize(e.target.value)}
                      value={size || ""}
                    >
                      <option value="">Select Size</option>
                      {product.sizeOfShoes &&
                        product.sizeOfShoes.map((sizes, index) => (
                          <option value={sizes} key={index}>
                            {sizes}
                          </option>
                        ))}
                    </select>
                  </label>

                  <label>
                    <span>Colour</span>
                    <select
                      onChange={(e) => setColour(e.target.value)}
                      value={colour || ""}
                    >
                      <option value="">Select Colour</option>
                      {product.colorOfShoes?.map((category, index) => (
                        <option value={category} key={index}>
                          {category}
                        </option>
                      ))}
                    </select>
                  </label>

                  <label className="product-detail-select-wide">
                    <span>Packaging</span>
                    <select
                      onChange={(e) => setSelectBox(e.target.value)}
                      value={selectBox || "0"}
                    >
                      <option value="0">Default Packing (Free)</option>
                      <option value="50">Simple Box ₹50</option>
                      <option value="150">Original Box ₹150</option>
                    </select>
                  </label>
                </div>

                <div className="product-detail-description">
                  <h2>Description</h2>
                  <button
                    type="button"
                    onClick={() =>
                      setIsDescriptionExpanded(!isDescriptionExpanded)
                    }
                  >
                    <p className={isDescriptionExpanded ? "expanded" : ""}>
                      {product.discription}
                    </p>
                    <span>
                      {isDescriptionExpanded ? "Show Less" : "Read More"}
                    </span>
                  </button>
                </div>

                {/* ══════════════════════════════════════════════════════════════
                    HOW WOULD YOU LIKE TO GET IT? (PURCHASE OPTIONS ENGINE)
                   ══════════════════════════════════════════════════════════════ */}
                <div className="im-purchase-section">
                  <span className="im-purchase-eyebrow">CHOOSE HOW TO BUY</span>
                  <h2 className="im-purchase-title">How would you like to get it?</h2>

                  <div className="im-purchase-options-list">
                    {/* A. Home Delivery */}
                    {homeDeliveryEnabled && (
                      <div className="im-purchase-option-card">
                        <div className="im-purchase-option-meta">
                          <div className="im-purchase-option-header">
                            <span className="im-option-icon-badge im-option-icon-badge--delivery">
                              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                                <rect x="1" y="3" width="15" height="13" rx="1.5"></rect>
                                <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon>
                                <circle cx="5.5" cy="18.5" r="2.5"></circle>
                                <circle cx="18.5" cy="18.5" r="2.5"></circle>
                              </svg>
                            </span>
                            <span className="im-purchase-option-name">Home Delivery</span>
                          </div>
                          <p className="im-purchase-option-desc">
                            Delivered to your doorstep {caps?.homeDelivery?.estimatedDays ? `(${caps.homeDelivery.estimatedDays})` : ''} &bull; {product.isdeliveryFree ? 'FREE' : `₹${product.shippingCharges || 50}`}
                          </p>
                        </div>
                        <div className="im-purchase-option-action">
                          <button
                            type="button"
                            onClick={() => handleOpenPurchaseOption("HOME_DELIVERY")}
                            className="im-purchase-btn"
                          >
                            Select
                          </button>
                        </div>
                      </div>
                    )}

                    {/* B. Pick Up From Shop */}
                    {storePickupEnabled && (
                      <div className="im-purchase-option-card">
                        <div className="im-purchase-option-meta">
                          <div className="im-purchase-option-header">
                            <span className="im-option-icon-badge im-option-icon-badge--pickup">
                              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                                <polyline points="9 22 9 12 15 12 15 22"></polyline>
                              </svg>
                            </span>
                            <span className="im-purchase-option-name">Pick Up From Shop</span>
                          </div>
                          <p className="im-purchase-option-desc">
                            Pay online, collect yourself at <strong>{storeInfo?.name || "Local Shop"}</strong> ({caps?.storePickup?.distanceFormatted || "Nearby"})
                          </p>
                        </div>
                        <div className="im-purchase-option-action">
                          <button
                            type="button"
                            onClick={() => handleOpenPurchaseOption("STORE_PICKUP")}
                            className="im-purchase-btn im-purchase-btn--outline"
                          >
                            Select
                          </button>
                        </div>
                      </div>
                    )}

                    {/* C. Reserve With Advance */}
                    {advanceReservationEnabled && (
                      <div className="im-purchase-option-card">
                        <div className="im-purchase-option-meta">
                          <div className="im-purchase-option-header">
                            <span className="im-option-icon-badge im-option-icon-badge--advance">
                              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                                <rect x="2" y="5" width="20" height="14" rx="2"></rect>
                                <line x1="2" y1="10" x2="22" y2="10"></line>
                                <circle cx="16" cy="15" r="1.5"></circle>
                              </svg>
                            </span>
                            <span className="im-purchase-option-name">Reserve With Advance</span>
                          </div>
                          <p className="im-purchase-option-desc">
                            Pay ₹{totalAdvance} now, rest (₹{totalRemainingAtShop}) at shop counter
                          </p>
                        </div>
                        <div className="im-purchase-option-action">
                          <button
                            type="button"
                            onClick={() => handleOpenPurchaseOption("RESERVE_ADVANCE")}
                            className="im-purchase-btn im-purchase-btn--outline"
                          >
                            Select
                          </button>
                        </div>
                      </div>
                    )}

                    {/* D. Book Product */}
                    {bookingEnabled && (
                      <div className="im-purchase-option-card">
                        <div className="im-purchase-option-meta">
                          <div className="im-purchase-option-header">
                            <span className="im-option-icon-badge im-option-icon-badge--booking">
                              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
                              </svg>
                            </span>
                            <span className="im-purchase-option-name">Book Product</span>
                          </div>
                          <p className="im-purchase-option-desc">
                            Hold it for you at the shop for 24h &bull; ₹0 upfront
                          </p>
                        </div>
                        <div className="im-purchase-option-action">
                          <button
                            type="button"
                            onClick={() => handleOpenPurchaseOption("BOOKING")}
                            className="im-purchase-btn im-purchase-btn--outline"
                          >
                            Select
                          </button>
                        </div>
                      </div>
                    )}

                    {/* E. Call Seller */}
                    {directCallEnabled && (
                      <div className="im-purchase-option-card">
                        <div className="im-purchase-option-meta">
                          <div className="im-purchase-option-header">
                            <span className="im-option-icon-badge im-option-icon-badge--call">
                              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                              </svg>
                            </span>
                            <span className="im-purchase-option-name">Call Seller</span>
                          </div>
                          <p className="im-purchase-option-desc">
                            Talk directly with {storeInfo?.name || "the shop"}
                          </p>
                        </div>
                        <div className="im-purchase-option-action">
                          <button
                            type="button"
                            onClick={handleCallSeller}
                            className="im-purchase-btn im-purchase-btn--call"
                          >
                            Call
                          </button>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Standard Add to Cart Secondary Button */}
                  <div style={{ marginTop: "16px", paddingTop: "14px", borderTop: "1px dashed #edf0f4", display: "flex", justifyContent: "flex-end" }}>
                    <button
                      type="button"
                      onClick={submitHandler}
                      disabled={product.productStock < 1}
                      style={{
                        background: "#f9fafb",
                        border: "1.5px solid #d1d5db",
                        borderRadius: "8px",
                        padding: "7px 16px",
                        fontSize: "12.5px",
                        fontWeight: "700",
                        color: "#374151",
                        cursor: "pointer",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px"
                      }}
                    >
                      <ShoppingCartIcon style={{ fontSize: "16px" }} />
                      Add to Shopping Cart
                    </button>
                  </div>
                </div>

                {/* ════════════ SOLD BY LOCAL MERCHANT CARD ════════════ */}
                <div style={{
                  background: "#ffffff",
                  border: "1.5px solid #edf0f4",
                  borderRadius: "14px",
                  padding: "18px",
                  margin: "18px 0"
                }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "12px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <div style={{
                        width: "42px",
                        height: "42px",
                        borderRadius: "8px",
                        background: "#fdf6f5",
                        color: "#8b2626",
                        display: "grid",
                        placeItems: "center",
                        fontSize: "18px",
                        fontWeight: "900"
                      }}>
                        {storeInfo?.logo?.imageurl || storeInfo?.logo ? (
                          <img src={storeInfo.logo?.imageurl || storeInfo.logo} alt="Logo" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "8px" }} />
                        ) : (
                          <StorefrontIcon />
                        )}
                      </div>
                      <div>
                        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                          <span style={{ fontSize: "11px", fontWeight: "900", color: "#8b2626", textTransform: "uppercase" }}>VERIFIED LOCAL SHOP</span>
                        </div>
                        <h3 style={{ fontSize: "15.5px", fontWeight: "900", color: "#111315", margin: "2px 0 0" }}>
                          {storeInfo?.name || "IM Online Merchant"}
                        </h3>
                      </div>
                    </div>

                    {storeInfo?.slug && (
                      <Link
                        to={`/shop/${storeInfo.slug}`}
                        style={{ fontSize: "12px", fontWeight: "800", color: "#8b2626", textDecoration: "none" }}
                      >
                        Visit Store &rarr;
                      </Link>
                    )}
                  </div>

                  <div style={{ fontSize: "12.5px", color: "#4b5563", marginBottom: "14px", display: "flex", alignItems: "center", gap: "6px" }}>
                    <LocationOnIcon style={{ fontSize: "16px", color: "#8b2626" }} />
                    <span>{storeInfo?.address?.street ? `${storeInfo.address.street}, ${storeInfo.address.city || ''}` : "Local Storefront · Verified Merchant"}</span>
                  </div>

                  {storeInfo?.phone && (
                    <div style={{ display: "flex", gap: "8px", marginTop: "10px" }}>
                      <a
                        href={`tel:${storeInfo.phone}`}
                        style={{
                          padding: "6px 12px",
                          borderRadius: "6px",
                          background: "#f0fdf4",
                          border: "1px solid #bbf7d0",
                          color: "#166534",
                          fontSize: "12px",
                          fontWeight: "700",
                          textDecoration: "none",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "6px"
                        }}
                      >
                        <PhoneIcon style={{ fontSize: "14px" }} />
                        {storeInfo.phone}
                      </a>
                    </div>
                  )}
                </div>
              </section>
            </div>

            {/* Reviews Section */}
            <div style={{ marginTop: "40px" }}>
              <Reviews productId={product._id} />
            </div>

            {/* Recently Viewed & Related Brands */}
            <RecentlyViewedProducts />
            <RealtedBrand category={product.category} currentProductId={product._id} />
          </div>

          <Footer />

          {/* Size Guide Dialog */}
          <Dialog
            open={sizeGuideOpen}
            onClose={() => setSizeGuideOpen(false)}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle style={{ borderBottom: "1px solid #edf0f4", fontWeight: "700" }}>
              Footwear Size Guide
            </DialogTitle>
            <DialogContent dividers style={{ padding: "20px 24px" }}>
              <p style={{ marginBottom: "16px", fontSize: "13px", color: "#666" }}>
                Standard Indian (UK / IND) footwear sizing conversion:
              </p>
              <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "center", fontSize: "13px" }}>
                <thead>
                  <tr style={{ background: "#f8f9fa", borderBottom: "1px solid #e5e7eb" }}>
                    <th style={{ padding: "10px", color: "#111" }}>UK / IND</th>
                    <th style={{ padding: "10px", color: "#111" }}>US</th>
                    <th style={{ padding: "10px", color: "#111" }}>EU</th>
                    <th style={{ padding: "10px", color: "#111" }}>Foot Length</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style={{ borderBottom: "1px solid #f1f5f9" }}><td style={{ padding: "8px" }}>6</td><td>7</td><td>40</td><td>24.5 cm</td></tr>
                  <tr style={{ borderBottom: "1px solid #f1f5f9" }}><td style={{ padding: "8px" }}>7</td><td>8</td><td>41</td><td>25.4 cm</td></tr>
                  <tr style={{ borderBottom: "1px solid #f1f5f9" }}><td style={{ padding: "8px" }}>8</td><td>9</td><td>42</td><td>26.2 cm</td></tr>
                  <tr style={{ borderBottom: "1px solid #f1f5f9" }}><td style={{ padding: "8px" }}>9</td><td>10</td><td>43</td><td>27.1 cm</td></tr>
                  <tr><td style={{ padding: "8px" }}>10</td><td>11</td><td>44</td><td>27.9 cm</td></tr>
                </tbody>
              </table>
            </DialogContent>
            <DialogActions style={{ padding: "12px 24px" }}>
              <Button onClick={() => setSizeGuideOpen(false)} color="primary" variant="contained">
                Close
              </Button>
            </DialogActions>
          </Dialog>

          {/* ══════════════════════════════════════════════════════════════
              INTERACTIVE PURCHASE & FULFILLMENT MODAL / WIZARD
             ══════════════════════════════════════════════════════════════ */}
          <Dialog
            open={isPurchaseModalOpen}
            onClose={() => !isProcessingPurchase && setIsPurchaseModalOpen(false)}
            maxWidth="sm"
            fullWidth
          >
            {purchaseSuccessData ? (
              <div>
                <DialogTitle style={{ textAlign: "center", paddingTop: "24px" }}>
                  <CheckCircleOutlineIcon style={{ fontSize: "56px", color: "#16a34a", marginBottom: "8px" }} />
                  <strong style={{ display: "block", fontSize: "20px", color: "#111315" }}>
                    {selectedPurchaseOption === "HOME_DELIVERY"
                      ? "Order Confirmed!"
                      : selectedPurchaseOption === "STORE_PICKUP"
                      ? "Pickup Order Confirmed!"
                      : selectedPurchaseOption === "RESERVE_ADVANCE"
                      ? "Reservation Confirmed!"
                      : "Product Booking Confirmed!"}
                  </strong>
                </DialogTitle>
                <DialogContent style={{ padding: "0 24px 20px" }}>
                  <p style={{ textAlign: "center", fontSize: "13.5px", color: "#4b5563", margin: "0 0 16px" }}>
                    {purchaseSuccessData.message}
                  </p>

                  {/* Verification Code Box */}
                  {purchaseSuccessData.verificationCode && (
                    <div className="im-verify-code-box">
                      <span style={{ fontSize: "11px", fontWeight: "800", color: "#6b7280", textTransform: "uppercase" }}>
                        YOUR PICKUP VERIFICATION CODE
                      </span>
                      <strong className="im-verify-code-val">
                        {purchaseSuccessData.verificationCode}
                      </strong>
                      <span style={{ fontSize: "12px", color: "#4b5563" }}>
                        Show this code at {storeInfo?.name || 'the shop'} counter upon collection.
                      </span>
                    </div>
                  )}

                  {/* Store Details */}
                  {storeInfo && (
                    <div style={{ background: "#f9fafb", borderRadius: "8px", padding: "12px 16px", marginBottom: "16px" }}>
                      <strong style={{ fontSize: "13px", color: "#111315", display: "block" }}>
                        Pickup Location: {storeInfo.name}
                      </strong>
                      <span style={{ fontSize: "12px", color: "#6b7280", display: "block", marginTop: "2px" }}>
                        {storeInfo.address?.street ? `${storeInfo.address.street}, ${storeInfo.address.city}` : "Storefront address"}
                      </span>
                      {storeInfo.phone && (
                        <span style={{ fontSize: "12px", color: "#166534", fontWeight: "700", display: "block", marginTop: "4px" }}>
                          Phone: {storeInfo.phone}
                        </span>
                      )}
                    </div>
                  )}

                  {/* Financial Summary */}
                  {purchaseSuccessData.financialBreakdown && (
                    <div className="im-fin-breakdown">
                      <div className="im-fin-row">
                        <span>Total Product Price:</span>
                        <span>₹{purchaseSuccessData.financialBreakdown.totalProductPrice}</span>
                      </div>
                      {purchaseSuccessData.financialBreakdown.deliveryFee > 0 && (
                        <div className="im-fin-row">
                          <span>Delivery Fee:</span>
                          <span>₹{purchaseSuccessData.financialBreakdown.deliveryFee}</span>
                        </div>
                      )}
                      {purchaseSuccessData.financialBreakdown.amountPaidNow > 0 && (
                        <div className="im-fin-row im-fin-row--advance">
                          <span>Paid Online Now:</span>
                          <span>₹{purchaseSuccessData.financialBreakdown.amountPaidNow}</span>
                        </div>
                      )}
                      {purchaseSuccessData.financialBreakdown.amountDueAtShop > 0 && (
                        <div className="im-fin-row im-fin-row--total">
                          <span>Due at Shop Counter:</span>
                          <span>₹{purchaseSuccessData.financialBreakdown.amountDueAtShop}</span>
                        </div>
                      )}
                    </div>
                  )}
                </DialogContent>
                <DialogActions style={{ padding: "16px 24px", justifyContent: "center" }}>
                  <Button
                    variant="contained"
                    onClick={() => {
                      setIsPurchaseModalOpen(false);
                      setPurchaseSuccessData(null);
                    }}
                    style={{ background: "#8b2626", color: "#ffffff", fontWeight: "800", textTransform: "none", padding: "8px 24px" }}
                  >
                    Done
                  </Button>
                </DialogActions>
              </div>
            ) : (
              <form onSubmit={handleExecutePurchase}>
                <DialogTitle style={{ borderBottom: "1px solid #edf0f4" }}>
                  <strong>
                    {selectedPurchaseOption === "HOME_DELIVERY"
                      ? "Buy Online & Get Delivered"
                      : selectedPurchaseOption === "STORE_PICKUP"
                      ? "Buy Online & Pick Up From Shop"
                      : selectedPurchaseOption === "RESERVE_ADVANCE"
                      ? `Reserve with ₹${totalAdvance} Advance`
                      : "Book Product (Free Shop Hold)"}
                  </strong>
                </DialogTitle>

                <DialogContent dividers style={{ padding: "20px 24px" }}>
                  {/* Product Brief Summary */}
                  <div style={{ display: "flex", gap: "12px", alignItems: "center", marginBottom: "16px", paddingBottom: "14px", borderBottom: "1px solid #edf0f4" }}>
                    <img
                      src={productImage}
                      alt={product.name}
                      style={{ width: "60px", height: "60px", objectFit: "cover", borderRadius: "8px" }}
                    />
                    <div style={{ flex: 1 }}>
                      <strong style={{ fontSize: "14px", color: "#111315", display: "block" }}>{product.name}</strong>
                      <span style={{ fontSize: "12px", color: "#6b7280" }}>
                        Qty: {quantity} • Size: {size || "Standard"} • Colour: {colour || "Standard"}
                      </span>
                      <span style={{ fontSize: "13px", fontWeight: "800", color: "#8b2626", display: "block", marginTop: "2px" }}>
                        ₹{totalItemPrice}
                      </span>
                    </div>
                  </div>

                  {/* Financial Breakdown Table */}
                  <div className="im-fin-breakdown">
                    <div className="im-fin-row">
                      <span>Product Price ({quantity}x):</span>
                      <span>₹{totalItemPrice}</span>
                    </div>
                    {selectedPurchaseOption === "HOME_DELIVERY" && (
                      <div className="im-fin-row">
                        <span>Delivery Fee:</span>
                        <span>{product.isdeliveryFree ? "FREE" : `₹${product.shippingCharges || 50}`}</span>
                      </div>
                    )}
                    {selectedPurchaseOption === "RESERVE_ADVANCE" && (
                      <>
                        <div className="im-fin-row im-fin-row--advance">
                          <span>Advance Payable Today:</span>
                          <span>₹{totalAdvance}</span>
                        </div>
                        <div className="im-fin-row">
                          <span>Balance Due at Shop Counter:</span>
                          <span>₹{totalRemainingAtShop}</span>
                        </div>
                      </>
                    )}
                    {selectedPurchaseOption === "BOOKING" && (
                      <div className="im-fin-row im-fin-row--advance">
                        <span>Payable Today:</span>
                        <span>₹0 (Pay ₹{totalItemPrice} at Shop)</span>
                      </div>
                    )}
                    <div className="im-fin-row im-fin-row--total">
                      <span>Total Amount:</span>
                      <span>₹{selectedPurchaseOption === "HOME_DELIVERY" ? totalItemPrice + (product.isdeliveryFree ? 0 : (product.shippingCharges || 50)) : totalItemPrice}</span>
                    </div>
                  </div>

                  {/* Customer Information Inputs */}
                  <h4 style={{ fontSize: "12.5px", fontWeight: "800", color: "#6b7280", textTransform: "uppercase", margin: "16px 0 10px" }}>
                    Your Contact & Collection Details
                  </h4>

                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", marginBottom: "10px" }}>
                    <TextField
                      label="Full Name"
                      size="small"
                      variant="outlined"
                      required
                      value={customerName}
                      onChange={(e) => setCustomerName(e.target.value)}
                    />
                    <TextField
                      label="10-Digit Mobile Number"
                      size="small"
                      variant="outlined"
                      required
                      value={customerPhone}
                      onChange={(e) => setCustomerPhone(e.target.value)}
                    />
                  </div>

                  <TextField
                    label="Email Address (Optional)"
                    size="small"
                    variant="outlined"
                    fullWidth
                    value={customerEmail}
                    onChange={(e) => setCustomerEmail(e.target.value)}
                    style={{ marginBottom: "10px" }}
                  />

                  {/* Multi-Location Pickup Selector */}
                  {selectedPurchaseOption !== "HOME_DELIVERY" && caps?.pickupLocations?.length > 0 && (
                    <div style={{ marginBottom: "12px", background: "#f8fafc", padding: "10px 12px", borderRadius: "8px", border: "1px solid #e2e8f0" }}>
                      <label style={{ fontSize: "11.5px", fontWeight: "800", color: "#334155", display: "block", marginBottom: "4px", textTransform: "uppercase" }}>
                        Choose Pickup Store / Warehouse Location
                      </label>
                      <select
                        value={customerPickupLocationId || (caps.pickupLocations[0]?._id || "")}
                        onChange={(e) => setCustomerPickupLocationId(e.target.value)}
                        style={{ width: "100%", padding: "8px 10px", borderRadius: "6px", border: "1.5px solid #cbd5e1", fontSize: "13px", fontWeight: "600" }}
                      >
                        {caps.pickupLocations.map((loc) => (
                          <option key={loc._id} value={loc._id}>
                            {loc.name} — {loc.address?.street}, {loc.address?.city}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {/* Delivery Specific Address Fields */}
                  {selectedPurchaseOption === "HOME_DELIVERY" && (
                    <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginTop: "6px" }}>
                      <TextField
                        label="Delivery Street Address"
                        size="small"
                        variant="outlined"
                        multiline
                        rows={2}
                        required
                        value={customerAddress}
                        onChange={(e) => setCustomerAddress(e.target.value)}
                      />
                      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
                        <TextField
                          label="City"
                          size="small"
                          variant="outlined"
                          required
                          value={customerCity}
                          onChange={(e) => setCustomerCity(e.target.value)}
                        />
                        <TextField
                          label="Pincode"
                          size="small"
                          variant="outlined"
                          required
                          value={customerPincode}
                          onChange={(e) => setCustomerPincode(e.target.value)}
                        />
                      </div>
                    </div>
                  )}

                  {/* Store Pickup / Reservation Location Notice */}
                  {selectedPurchaseOption !== "HOME_DELIVERY" && storeInfo && (
                    <div style={{ background: "#fdf6f5", border: "1px solid #fed7d7", borderRadius: "8px", padding: "12px", marginTop: "12px" }}>
                      <strong style={{ fontSize: "12.5px", color: "#8b2626", display: "block" }}>
                        📍 Collect at: {storeInfo.name}
                      </strong>
                      <span style={{ fontSize: "12px", color: "#4b5563", display: "block", marginTop: "2px" }}>
                        {storeInfo.address?.street ? `${storeInfo.address.street}, ${storeInfo.address.city}` : "Local Shop"}
                      </span>
                      <span style={{ fontSize: "11.5px", color: "#6b7280", display: "block", marginTop: "4px" }}>
                        Store Hours: {storeInfo.businessHours || "10:00 AM - 9:00 PM"}
                      </span>
                    </div>
                  )}
                </DialogContent>

                <DialogActions style={{ padding: "14px 24px" }}>
                  <Button onClick={() => setIsPurchaseModalOpen(false)} disabled={isProcessingPurchase} style={{ textTransform: "none" }}>
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={isProcessingPurchase}
                    style={{ background: "#8b2626", color: "#ffffff", fontWeight: "800", textTransform: "none", padding: "8px 20px" }}
                  >
                    {isProcessingPurchase
                      ? "Processing..."
                      : selectedPurchaseOption === "HOME_DELIVERY"
                      ? "Confirm & Pay Online"
                      : selectedPurchaseOption === "STORE_PICKUP"
                      ? "Pay & Get Pickup Code"
                      : selectedPurchaseOption === "RESERVE_ADVANCE"
                      ? `Pay ₹${totalAdvance} Advance`
                      : "Confirm Booking (Free)"}
                  </Button>
                </DialogActions>
              </form>
            )}
          </Dialog>
        </Fragment>
      )}
    </Fragment>
  );
}

export default Productcartdetail;
